import { union } from 'io-ts/Decoder';

import { Id as FpcJobId } from '../fpc/job/Id';
import { Id as JobId } from '../job/Id';
import { Id as ProjectId } from '../project/Id';
import { Id as TransactionId } from '../transaction/Id';

export const ParentId = union(JobId, FpcJobId, TransactionId, ProjectId);
